import {useState} from "react";
import {com, space} from "../../provider_api";
import {useRpcSender} from "../RpcSender";
import {RpcState} from "../RpcState";
import GetStripeUrlResponse = com.onkensu.platform.billing.GetStripeUrlResponse;
import IProviderSubscriptionRequest = com.onkensu.platform.billing.IProviderSubscriptionRequest;
import ProviderSubscriptionRequest = com.onkensu.platform.billing.ProviderSubscriptionRequest;

export const useNewSubscriptionLink = () => {

  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: "none"});
  
  const send = (request: IProviderSubscriptionRequest) => {
    setRpcState({state: 'pending'});
      rpcSender.send('create_provider_checkout_session', ProviderSubscriptionRequest.encode(request).finish())
        .then(r => {
          let response = GetStripeUrlResponse.decode(r);
          window.location.assign(response.stripeUrl);
        })
        .catch(e => {
          console.log('Error booking.. ', e);
          setRpcState({state: 'error', message: 'Server error booking class!'});
        });
  }

  return {rpcState, send};
}